const getColLength = (c) => c.hidden ?
    0 :
    Array.isArray(c.name) ?
        c.name.length :
        1;
export default (columns) => Math.max(...columns.map(getColLength));
